var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroBgShape1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1211 370",
    style: {
      enableBackground: "new 0 0 1211 370"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,318c0,2,6,5.9,7.5,6.9c34.3,22.6,70.4,4.6,99.9-16.1c58.4-40.9,132.8-26.7,198-14.7 c22.1,4.1,44.8,8.8,67.2,4.6c31.5-5.9,55-31.3,78-51.4c26.7-23.4,56.3-45.1,87-62.8c12.9-7.4,26.2-14,40.1-19.3 c75.8-29,152.8,1.9,227.6,18.9c4,0.9,8,1.8,11.9,2.6c85.3,18.5,132.7-45,185.5-99.5c29.2-30.1,66.6-51.8,111.2-65.5 c22.1-6.8,45-11.1,68.6-12.7c9.5-0.7,19-1.3,28.5-1.9c0,120.9,0,241.9,0,362.9c-403.8,0-807.5,0-1211.2,0C0,370,0,318,0,318z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBgShape1);
export default __webpack_public_path__ + "static/media/hero-bg-shape-1.68866119a0740b5ad452ccd039048178.svg";
export { ForwardRef as ReactComponent };